import { render, staticRenderFns } from "./PictureInPicture.vue?vue&type=template&id=12d24652&scoped=true"
import script from "./PictureInPicture.vue?vue&type=script&lang=ts"
export * from "./PictureInPicture.vue?vue&type=script&lang=ts"
import style0 from "./PictureInPicture.vue?vue&type=style&index=0&id=12d24652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d24652",
  null
  
)

export default component.exports